import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button,
    Avatar
} from '@mui/material';

import {
    HomeOutlined,
    CompareArrowsOutlined,
    ChecklistOutlined,
    LocalShippingOutlined,
    FolderOpenOutlined,
    StarBorderOutlined,
    InfoOutlined,
    CheckCircleOutline,
    ArrowForwardIos
} from '@mui/icons-material';

// スクロール用の関数
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80; // ヘッダーの高さ分のオフセット
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: { xs: 1, sm: 3 } }}>
            {/* 目次 */}
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>目次</Typography>
                            <Button variant="outlined" size="small" onClick={() => setShowToc(false)} sx={{ ml: 2 }}>
                                閉じる
                            </Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#666', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.98rem' }}>
                                    ルームシェア住み替えの魅力と背景
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#666', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('compare')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.98rem' }}>
                                    物件比較のポイント
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#666', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('procedure')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.98rem' }}>
                                    住み替え手続きの流れ
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#666', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('organize')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.98rem' }}>
                                    荷物整理・引越し術
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#666', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('experience')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.98rem' }}>
                                    住み替え体験談とアドバイス
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#666', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('summary')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.98rem' }}>
                                    まとめ：理想の住み替えを叶えるために
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                >
                    目次を表示
                </Button>
            )}

            {/* 導入 */}
            <Box id="introduction" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    ルームシェア住み替えの魅力と背景
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" paragraph>
                    ルームシェアは、一人暮らしでは味わえないコミュニケーションやコスト面のメリットが魅力です。しかし、同じ場所に長く住むほどに「もっと自分に合った環境で暮らしたい」「新しい刺激や快適さを求めたい」と感じることも多いのではないでしょうか。
                </Typography>
                <Typography variant="body1" paragraph>
                    住み替えは、そんなあなたのライフスタイルや価値観に柔軟にフィットさせる絶好のチャンスです。新しい物件やルームメイト、周辺環境との出会いが、人生に新しい風を吹き込んでくれるはず。<b>でも、いざ住み替えを決意した時、「何から始めればいいの…？」と悩む人も多い</b>のが現実です。
                </Typography>
                <Typography variant="body1" paragraph>
                    本記事では、<Chip label="物件比較" color="primary" variant="outlined" size="small" sx={{ mr: 1 }} />
                    <Chip label="手続き" color="primary" variant="outlined" size="small" sx={{ mr: 1 }} />
                    <Chip label="荷物整理" color="primary" variant="outlined" size="small" />
                    など、「住み替え時にやるべきこと」を体系的に解説。<b>実際の体験談</b>や専門的な視点も交えながら、理想の新生活にスムーズに移行するためのノウハウを余すことなくご紹介します。
                </Typography>
                <Box sx={{ my: 4 }}>

                </Box>
            </Box>

            {/* 物件比較のポイント */}
            <Box id="compare" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <CompareArrowsOutlined sx={{ mr: 1, mb: '-4px', color: 'primary.main' }} />
                    物件比較のポイント
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" paragraph>
                    住み替え先選びは、ルームシェア生活の質を左右する重要な工程。単なる家賃や立地だけでなく、「どんな人と、どんな空間で暮らすか」まで視野を広げて比較しましょう。以下のチェックリストを活用し、後悔のない選択を！
                </Typography>
                <Paper sx={{ mb: 3, p: 2, bgcolor: '#fafafa', borderRadius: 2, boxShadow: 0 }}>
                    <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
                        <ChecklistOutlined sx={{ mr: 1, color: 'primary.main' }} />
                        物件比較チェックリスト
                    </Typography>
                    <List>
                        <ListItem>
                            <ListItemIcon><HomeOutlined color="primary" /></ListItemIcon>
                            <ListItemText
                                primary={<b>家賃・初期費用</b>}
                                secondary="家賃のほか、共益費・光熱費・敷金礼金などのトータルコストを要確認。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CompareArrowsOutlined color="primary" /></ListItemIcon>
                            <ListItemText
                                primary={<b>立地・アクセス</b>}
                                secondary="通勤・通学、買い物、生活圏の利便性を地図や実地で確認。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><StarBorderOutlined color="primary" /></ListItemIcon>
                            <ListItemText
                                primary={<b>設備・共有スペース</b>}
                                secondary="キッチン・バス・トイレなど設備の清潔度や、リビングの広さ・雰囲気も要チェック。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><InfoOutlined color="primary" /></ListItemIcon>
                            <ListItemText
                                primary={<b>ルームメイト探し</b>}
                                secondary="年齢層・性別・職業・生活リズム、今のルームメイトと継続？新しく探す？"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleOutline color="primary" /></ListItemIcon>
                            <ListItemText
                                primary={<b>契約条件・管理体制</b>}
                                secondary="契約期間や退去規定、管理会社のレスポンスも確認。"
                            />
                        </ListItem>
                    </List>
                </Paper>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ mb: { xs: 2, sm: 0 } }}>

                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body2" sx={{ mb: 2 }}>
                            <b>ワンポイント</b>: 内見時は「朝・夜」どちらも足を運ぶと、実際の生活イメージが掴みやすくなります。<br />
                            また、「内見時にルームメイトと軽く話してみる」のもおすすめ。雰囲気や価値観のミスマッチを事前に防げます。
                        </Typography>
                        <Chip label="家賃重視" color="primary" size="small" sx={{ mr: 1 }} />
                        <Chip label="コミュニティ重視" color="success" variant="outlined" size="small" sx={{ mr: 1 }} />
                        <Chip label="立地重視" color="secondary" variant="outlined" size="small" />
                    </Grid>
                </Grid>
            </Box>

            {/* 住み替え手続きの流れ */}
            <Box id="procedure" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <LocalShippingOutlined sx={{ mr: 1, mb: '-4px', color: 'primary.main' }} />
                    住み替え手続きの流れ
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" paragraph>
                    住み替えには「現住居の退去」「新住居の契約」「各種住所変更」など、細かな手続きが必要。計画的に進めることで、トラブルや二重家賃を防げます。
                </Typography>
                <Paper sx={{ p: 2, bgcolor: '#f5fafd', borderRadius: 2, boxShadow: 0 }}>
                    <List>
                        <ListItem alignItems="flex-start">
                            <ListItemIcon>
                                <ArrowForwardIos color="primary" sx={{ fontSize: 22 }} />
                            </ListItemIcon>
                            <ListItemText
                                primary={<b>1. 退去意思の連絡（1ヶ月〜2ヶ月前）</b>}
                                secondary="管理会社や現ルームメイトに早めに連絡を。退去予告期間を要確認。"
                            />
                        </ListItem>
                        <ListItem alignItems="flex-start">
                            <ListItemIcon>
                                <ArrowForwardIos color="primary" sx={{ fontSize: 22 }} />
                            </ListItemIcon>
                            <ListItemText
                                primary={<b>2. 新物件の契約・初期費用支払い</b>}
                                secondary="入居審査や契約書類の手続き。保証人が必要な場合も。"
                            />
                        </ListItem>
                        <ListItem alignItems="flex-start">
                            <ListItemIcon>
                                <ArrowForwardIos color="primary" sx={{ fontSize: 22 }} />
                            </ListItemIcon>
                            <ListItemText
                                primary={<b>3. 引越し日程・業者手配</b>}
                                secondary="荷物量や予算に応じて業者選定・予約。自力引越しなら友人への協力依頼も。"
                            />
                        </ListItem>
                        <ListItem alignItems="flex-start">
                            <ListItemIcon>
                                <ArrowForwardIos color="primary" sx={{ fontSize: 22 }} />
                            </ListItemIcon>
                            <ListItemText
                                primary={<b>4. 住所変更・ライフライン手続き</b>}
                                secondary="郵便局転送、役所での住所変更、電気・ガス・水道・ネットの移転手続きなど。"
                            />
                        </ListItem>
                        <ListItem alignItems="flex-start">
                            <ListItemIcon>
                                <ArrowForwardIos color="primary" sx={{ fontSize: 22 }} />
                            </ListItemIcon>
                            <ListItemText
                                primary={<b>5. 現住居の原状回復・退去立会い</b>}
                                secondary="掃除・修繕・鍵返却などを行い、敷金返還のトラブルを防止。"
                            />
                        </ListItem>
                    </List>
                </Paper>
                <Typography variant="body2" sx={{ mt: 2 }}>
                    必要書類や期日は物件や管理会社によって異なります。<b>事前のスケジュール管理</b>と、<b>各種書類のコピー保管</b>をお忘れなく！
                </Typography>
            </Box>

            {/* 荷物整理・引越し術 */}
            <Box id="organize" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <FolderOpenOutlined sx={{ mr: 1, mb: '-4px', color: 'primary.main' }} />
                    荷物整理・引越し術
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" paragraph>
                    ルームシェア住み替えは、ライフスタイルを見直す絶好のタイミング。荷物の“断捨離”や効率的なパッキングで、引越しの負担を大きく減らせます。専門家視点でのおすすめ整理術をご紹介！
                </Typography>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} md={6}>
                        <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 0, bgcolor: '#fafafa' }}>
                            <Typography variant="h6" sx={{ mb: 1, fontSize: '1.1rem' }}>
                                荷物整理のコツ
                            </Typography>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon><CheckCircleOutline color="primary" /></ListItemIcon>
                                    <ListItemText primary="1年以上使っていない物は手放す" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><CheckCircleOutline color="primary" /></ListItemIcon>
                                    <ListItemText primary="衣類は季節ごとに分け、不要品はフリマ・寄付へ" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><CheckCircleOutline color="primary" /></ListItemIcon>
                                    <ListItemText primary="書類や小物はカテゴリごとにラベル管理" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><CheckCircleOutline color="primary" /></ListItemIcon>
                                    <ListItemText primary="貴重品・重要書類は専用ボックスでまとめる" />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 0, bgcolor: '#f5fafd' }}>
                            <Typography variant="h6" sx={{ mb: 1, fontSize: '1.1rem' }}>
                                引越しパッキング術
                            </Typography>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon><LocalShippingOutlined color="primary" /></ListItemIcon>
                                    <ListItemText primary="重い物は小箱、軽い物は大箱へ" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><LocalShippingOutlined color="primary" /></ListItemIcon>
                                    <ListItemText primary="箱ごとに「部屋名」「内容」を明記" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><LocalShippingOutlined color="primary" /></ListItemIcon>
                                    <ListItemText primary="割れ物は衣類やタオルで包む" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><LocalShippingOutlined color="primary" /></ListItemIcon>
                                    <ListItemText primary="数日分の生活用品は手持ちバッグに" />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                </Grid>
                <Box sx={{ mb: 2 }}>
                    <img
                        src="/images/blog/moving-packing_roomshare-sumikai-checklist.jpg"
                        alt="段ボール箱を効率的に積み上げたり、ラベル付けしながら引越し準備を進める若者たち。明るい日差しの入る部屋で、整理整頓と断捨離を楽しむ様子が映っており、新生活への期待感が漂っている"
                        style={{ width: '100%', borderRadius: 8 }}
                    />
                </Box>
                <Typography variant="body2">
                    <b>ポイント：</b>「荷造りチェックリスト」を紙かスマホで作成し、進捗を見える化するとストレスフリー。<br />
                    また、<b>不要品は早めに処分・譲渡</b>しておくと、当日の引越しが驚くほど楽になります。
                </Typography>
            </Box>

            {/* 住み替え体験談とアドバイス */}
            <Box id="experience" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <InfoOutlined sx={{ mr: 1, mb: '-4px', color: 'primary.main' }} />
                    住み替え体験談とアドバイス
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" paragraph>
                    実際に住み替えを経験した方のリアルな声は、計画や準備のヒントが満載。ここでは、実例とともに「やって良かったこと」「気を付けるべきこと」をご紹介します。
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Card sx={{ maxWidth: 345, mb: 2 }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <Avatar src="/images/avatars/user1.jpg" sx={{ mr: 2 }} />
                                    <Typography variant="subtitle1" fontWeight="bold">Kさん（30代・会社員）</Typography>
                                </Box>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    <StarBorderOutlined sx={{ fontSize: 18, verticalAlign: 'middle', color: 'primary.main', mr: 0.5 }} />
                                    <b>「内見時に徹底的に利便性をチェック」</b>
                                </Typography>
                                <Typography variant="body2">
                                    物件の設備だけでなく、周辺環境を含め徹底的にルームシェアしたあとの生活イメージを想定。実際の生活も安心してスタートできました。
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Card sx={{ maxWidth: 345, mb: 2 }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <Avatar src="/images/avatars/user2.jpg" sx={{ mr: 2 }} />
                                    <Typography variant="subtitle1" fontWeight="bold">Sさん（20代・学生）</Typography>
                                </Box>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    <StarBorderOutlined sx={{ fontSize: 18, verticalAlign: 'middle', color: 'primary.main', mr: 0.5 }} />
                                    <b>「荷物は思い切って半分に減らした」</b>
                                </Typography>
                                <Typography variant="body2">
                                    引越しを機に断捨離を徹底。持ち物を厳選したことで、引越し費用も安くなり、新居での収納もスッキリ。「本当に必要なモノだけ」に囲まれる心地よさを実感しています。
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Box sx={{ my: 3 }}>

                </Box>
                <Paper sx={{ p: 2, borderRadius: 2, bgcolor: '#f9fbe7', boxShadow: 0 }}>
                    <Typography variant="h6" sx={{ mb: 1, fontSize: '1.1rem' }}>
                        住み替え経験者が語る「やってよかったこと」
                    </Typography>
                    <List dense>
                        <ListItem>
                            <ListItemIcon><CheckCircleOutline color="success" /></ListItemIcon>
                            <ListItemText primary="退去と入居のタイミングを調整し、二重家賃を回避" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleOutline color="success" /></ListItemIcon>
                            <ListItemText primary="早めに荷物整理を始め、不要品をメルカリで売却" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleOutline color="success" /></ListItemIcon>
                            <ListItemText primary="現住居の掃除を徹底し、敷金トラブルなし" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleOutline color="success" /></ListItemIcon>
                            <ListItemText primary="LINEグループで新旧ルームメイトと事前に情報共有" />
                        </ListItem>
                    </List>
                </Paper>
            </Box>

            {/* まとめ */}
            <Box id="summary" sx={{ mb: 8 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <ChecklistOutlined sx={{ mr: 1, mb: '-4px', color: 'primary.main' }} />
                    まとめ：理想の住み替えを叶えるために
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" paragraph>
                    ルームシェアの住み替えは、環境や人間関係を刷新し、より自分らしい暮らしを実現できる絶好の機会です。<br />
                    「物件比較」「手続き」「荷物整理」「体験談」それぞれのポイントを押さえることで、スムーズかつ後悔のない住み替えが叶います。
                </Typography>
                <Typography variant="body1" paragraph>
                    最後に大切なのは、<b>一人で抱え込まず、ルームメイトや管理会社としっかりコミュニケーションを取ること</b>。新しい住まいでのスタートが、あなたにとって素晴らしいものとなりますように！
                </Typography>
                <Box sx={{ mt: 3 }}>
                    <Chip label="理想の住み替え" color="primary" size="medium" sx={{ mr: 1, fontWeight: 'bold' }} />
                    <Chip label="ルームシェア生活向上" color="success" variant="outlined" size="medium" />
                </Box>
            </Box>
        </Box>
    );
};

const post = {
    id: 'roomshare-sumikai-checklist',
    slug: 'roomshare-sumikai-checklist',
    title: 'ルームシェアの「住み替え」時にやるべきことリスト',
    excerpt: 'ルームシェア住み替え時の物件比較ポイント、手続きの流れ、荷物整理術、実際の体験談を専門的かつ具体的にまとめました。新生活をスムーズにスタートするための必見ガイドです。',
    coverImage: '/images/blog/cover-living-room-roomshare_roomshare-sumikai-checklist.jpg',
    coverImageAlt: '明るい自然光が差し込むモダンなルームシェアの共有リビングで、多様な背景を持つルームメイトたちが楽しく会話をしている様子。ナチュラルな家具とグリーンが温かく、快適で開放的な新生活のイメージを表現している',
    publishedAt: '2024-06-11T09:00:00+09:00',
    isPublished: true,
    categories: ['ルームシェア', '引越し', '住み替え'],
    tags: ['物件比較', '手続き', '荷物整理', '体験談', 'ルームシェア'],
    author: {
        name: '中村 葵',
        avatar: '/images/avatars/aoi-nakamura.jpg',
        bio: 'ルームシェア・賃貸住み替え分野で多数のコラム執筆。自身も複数回のルームシェア経験を持ち、実践的なアドバイスが好評。',
        profilePicture: '/images/avatars/aoi-nakamura.jpg'
    },
    viewCount: 1075,
    contentComponent: PostContent
};

export default post;